import { ClientOnly } from "@tanstack/react-router";
import type { YouTubeEvent } from "react-youtube";
import { cn } from "ui";

import { YouTubeClientComponent } from "src/components/YouTubeClientComponent";
import { YouTubeFallback } from "src/components/YouTubeFallback";

export interface CustomYouTubeProps {
  videoId: string;
  width?: number | string;
  height?: number | string;
  autoplay?: boolean;
  className?: string;
  playerClassName?: string;
  fallbackClassName?: string;
  iframeClassName?: string;
  onReady?: (event: YouTubeEvent) => void;
  onPlay?: (event: YouTubeEvent) => void;
  onPause?: (event: YouTubeEvent) => void;
  onEnd?: (event: YouTubeEvent) => void;
  onError?: (event: YouTubeEvent) => void;
  onStateChange?: (event: YouTubeEvent) => void;
}

export function YouTube(props: CustomYouTubeProps) {
  return (
    <ClientOnly
      fallback={
        <YouTubeFallback
          width={props.width}
          height={props.height}
          className={props.className}
          fallbackClassName={props.fallbackClassName}
        />
      }
    >
      <YouTubeClientComponent
        {...props}
        className={cn("w-full h-[480px]", props.playerClassName)}
        iframeClassName={cn(
          "w-full h-[480px]",
          props.className,
          props.iframeClassName,
        )}
      />
    </ClientOnly>
  );
}
